/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface LoadingModalProps {
  title: string
  onBackdropClick: (e: React.MouseEvent) => void
  onClose: () => void
}

/**
 * Shared Loading Modal Component
 *
 * Displays a loading spinner with modal backdrop.
 * Used across workflow modals to reduce duplication.
 */
export const LoadingModal: React.FC<LoadingModalProps> = ({ title, onBackdropClick, onClose }) => {
  return (
    <div className="theme-sandman">
      <div className="modal-backdrop fade in" onClick={onBackdropClick} aria-hidden="true" />
      <div className="modal fade in" style={{ display: 'block' }} tabIndex={-1} role="dialog" onClick={onBackdropClick}>
        <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={onClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <i className="fa fa-spinner fa-spin fa-2x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingModal
